import api from '@/api';
import { getMetaInfo } from '@/lib/request/index';

const state = {
  errno: 0,
  loading: false,
  ordersInfos: [],
  // 卡片相关的信息
  layoutCards: {},
  // 地图相关的信息
  orderData: {},
  serverApiTime: 0,
  // 欠款单loading
  debtRepayLoading: false,
};

const mutations = {
  /** @desc 获取订单页信息 */
  setOrderDetailInfo(state, data) {
    // 订单id传一个
    const orderInfos = data?.orders[0];
    state.orderData = orderInfos?.orderData;
    state.serverApiTime = getMetaInfo(data)?.time;
    const layoutCards = {};
    orderInfos?.layouts.map((layout) => {
      layout?.cards.map((card) => {
        const cardKey = card.template.slice(4);
        layoutCards[cardKey] = card;
      });
    });
    state.layoutCards = { ...layoutCards };
    state.ordersInfos = data?.orders;
  },
  setOrderLoading(state, data) {
    state.debtRepayLoading = data;
  },
};

const actions = {
  /** @desc 获取订单页信息 */
  async getOrderDetailInfo({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.getOrderDetail(param);
      commit('setOrderDetailInfo', res);
      state.errno = 0;
      state.loading = false;
      return res;
    } catch (err) {
      state.errno = err.errno;
      state.loading = false;
      return err?.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
